import React, { useEffect, useState } from "react";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import { getMSAuthToken } from "../../utils/MsGraphApiCall";
import { GraphFileBrowser } from "@microsoft/file-browser";
import { PageHeader, PageShell } from "../../components/UI/Page";
import { LoadingState } from "../../components/UI/States";

const CommonStock = () => {
  const [token, setToken] = useState(null);

  const getAuthenticationToken = () => {
    if (token) {
      return new Promise((resolve) => {
        resolve(token);
      });
    }
  };

  useEffect(() => {
    getMSAuthToken(setToken);
  }, []);

  useEffect(() => {
    // Find the element with the data-automationid attribute
    const elementToHide = document.querySelector(
      '[data-automationid="malwareDownloadCommand"]'
    );

    // Check if the element exists before attempting to hide it
    if (elementToHide) {
      elementToHide.style.display = "none";
    }
  }, [token]);

  return (
    <PageShell size="2xl">
      <PageHeader
        icon={FolderSharedIcon}
        tone="orange"
        eyebrow="SBCF"
        title="Truss & Panel Documents"
        description="Browse shared SBCF documents."
      />
      <div className="app-card overflow-hidden rounded-2xl border p-2">
        {token ? (
          // The SharePoint browser ships its own light (Fluent UI) styling,
          // so it sits on a deliberate light island in every theme.
          <div className="app-light-surface min-h-[24rem] overflow-hidden rounded-xl bg-white text-slate-900">
            <GraphFileBrowser
              getAuthenticationToken={getAuthenticationToken}
              endpoint="https://graph.microsoft.com/v1.0/sites/bigclumberinc.sharepoint.com,1d5cd21c-1bab-4e4d-91d1-97308132fcb4"
              itemId="01EJATJ6KOT573DZ4OWRDKXQNDBUTAVCC2"
            />
          </div>
        ) : (
          <LoadingState label="Connecting to SharePoint…" />
        )}
      </div>
    </PageShell>
  );
};

export default CommonStock;
